import { ReactElement, ReactNode } from 'react';
import { usePeriod } from '../usePeriod';
import { DatePartPickerField } from 'components';
import type { BlockState } from 'modules/campaign/block/types';
import { StateFilterField, TypeFilterField } from '../Filter';

export interface FilterState {
  year: string;
  state: BlockState[];
}

interface FilterProps {
  global: boolean;
  children?: ReactNode;
}

export function Filter({ global, children }: FilterProps): ReactElement {
  const { date_from: minDate, date_to: maxDate } = usePeriod();
  return (
    <div className="flex-column">
      <div className="d-flex flex-row">
        <DatePartPickerField part="year" name="year" minDate={minDate} maxDate={maxDate} />
        {children}
      </div>

      <div className="d-flex flex-row">
        <StateFilterField />
        <TypeFilterField global={global} className="ml-1" />
      </div>
    </div>
  );
}
